import processReport from '@/assets/js/report/order'
export default {
  methods: {
    async genereateReportContent (id) {
      const getObj = this.listPayloadObj.list ? this.listPayloadObj.list.find(x => x.id === id) : {}
      const customerLang = (getObj && getObj.customerlanguage) ? getObj.customerlanguage : this.$i18n.locale
      const lang = this.$i18n.messages[customerLang].message
      if (getObj) {
        const headers = [{ text: lang.orders.productNo, value: 'number', width: '12%' },
          { text: lang.customer.name, value: 'producttext', width: '30%' },
          { text: lang.invoice.qty, value: 'qty', width: '7%' },
          { text: lang.product.unit, value: 'productunit_name', width: '5%' },
          { text: lang.orders.price, value: 'price', width: '12%' },
          { text: `${lang.product.discount} %`, value: 'discount', width: '9%' },
          { text: lang.customer.vatValue, value: 'vat', width: '10%' },
          { text: lang.common.total, value: 'total', width: '12%' },
          { text: 'DG', value: 'dg' }
        ]
        const products = await this.getOrderProducts(getObj.id, getObj.type)
        const translationData = {
          confirm: (getObj.type === 'offer') ? lang.layout.offer : lang.common.orderConfirm,
          number: (getObj.type === 'offer') ? lang.order.offerNumber : lang.order.orderNumber,
          customer: lang.order.customer,
          contact: lang.orders.contact,
          deliveryaddress: lang.orders.deliveryAddress,
          responsible: lang.deviations.responsible,
          ourreference: lang.orders.ourReference,
          yourreference: lang.orders.yourReference,
          offerdate: lang.orders.offerDate,
          orderdate: lang.whOrder.orderDate,
          deliverydate: lang.order.shippingDate,
          total: lang.orders.totalSum,
          totalExVat: lang.orders.totalExVat,
          totalDG: lang.common.total,
          shipment: lang.customer.shipmentReport,
          paymentTerm: lang.order.paymentTerms,
          invoiceTo: lang.orders.invoiceTo,
          invoiceAddress: lang.orders.invoiceAddress,
          days: lang.common.days,
          totalVAT: lang.order.totalVAT,
          currency: lang.product.currency
        }
        const getBase64Content = processReport(headers, products, getObj, translationData)
        return getBase64Content
      }
    },
    getOrderProducts (id, type) {
      return new Promise((resolve, reject) => {
        const query = {
          expand: [{
            select: ['number', 'name', 'available'],
            model: 'Product',
            on_field: 'id',
            on_parent_field: 'productid'
          }, {
            select: ['name'],
            model: 'ProductUnit',
            on_field: 'id',
            on_parent_field: 'unitid'
          }],
          filter: `orderid eq '${id}'`
        }
        this.$_executeApi('post', 'ordermaterials/query', query)
          .then((response) => {
            if (response.data) {
              const transformData = { number: { list: ['qty', 'price', 'discount', 'vat', 'total'], format: 'replaceDotWithComma' } }
              const itemsObj = this.$_formatListModel(response.data, transformData)
              itemsObj.map(x => {
                if (x.isfreight) {
                  x.producttext = 'Frakt'
                  x.number = '1000'
                }
                return x
              })
              resolve(itemsObj)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
